export default "<p>avatar-upload works!</p>\n";